<template>
    <div class="position-relative">
        <input-checkbox
            :value="!!value"
            @update:value="input"
        >
            {{ ucfirst($t("common.accept(TermsConditions)")) }}
            &nbsp;
            <button
                :class="$css($theme.linkPrimary)"
                @click.prevent="showModal"
            >
                {{ $t("common.termsAndConditions") }}
            </button>
        </input-checkbox>

        <input-status :status="status" />
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import InputCheckbox from "~/components/inputs/InputCheckbox"
import HtmlModal from "~/components/DialogBox/HtmlModal"
import InputStatus from "~/components/inputs/InputStatus"

export default {
    inject: ["pushModal"],

    props: {
        ...InputStatus.props,

        disclaimerId: Number,
        value: Number,
        text: String,
    },

    emits: ["update:value"],

    methods: {
        showModal() {
            this.pushModal(HtmlModal, {
                props: {
                    text: this.text,
                },
                layerClass: "d-flex bg--black--50",
            })
        },

        input(e) {
            // we convert false into null to prevent
            // the event bypasses the "required" validator
            const val = e ? this.disclaimerId : null
            this.$emit("update:value", val)
        },

        ucfirst,
    },

    components: {
        InputCheckbox,
        InputStatus,
    },
}
</script>
